

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductTelephoneCompanyService } from '../../../services/product-telephone-company.service';

@Component({
  selector: 'app-view-product-telephone-companies',
  templateUrl: './view-product-telephone-companies.component.html',
  styleUrls: ['./view-product-telephone-companies.component.css'],
  providers:[ProductTelephoneCompanyService]
})
export class ViewProductTelephoneCompaniesComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  productTelephoneCompany: any = {
    laptops: false,
    consoles: false,
    products: false,
    mobiles: false
  };
  constructor(private productTelephoneCompanyService:ProductTelephoneCompanyService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getProductTelephoneCompany();
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getProductTelephoneCompany(){
    this.productTelephoneCompanyService.get(this.id).subscribe((productTelephoneCompany) => {
      this.productTelephoneCompany = productTelephoneCompany;
    });
  }
  

  saveProductTelephoneCompany(){
    this.parseProductsType();
    if (this.productTelephoneCompany.id == undefined){
      this.productTelephoneCompanyService.create(this.returnProductTelephoneCompanyProperties(this.productTelephoneCompany))
      .subscribe((productTelephoneCompany) => {
        this.productTelephoneCompanyService.get(productTelephoneCompany.id).subscribe((productTelephoneCompany) => {
          this.productTelephoneCompany = productTelephoneCompany;
          this.router.navigate(['/configuration/producttelephonecompanies']);
        });
      });
    }else{
      this.productTelephoneCompanyService.update(this.returnProductTelephoneCompanyProperties(this.productTelephoneCompany))
      .subscribe((productTelephoneCompany) => {
        this.productTelephoneCompany = productTelephoneCompany;
      });
    }
  }

  returnProductTelephoneCompanyProperties(productTelephoneCompany){
    var properties = {
      name: productTelephoneCompany.name,
      product_types: productTelephoneCompany.product_types
    }
    if (productTelephoneCompany.id){
      properties['id'] = productTelephoneCompany.id;
    }
    return properties;
  }

  parseProductsType(){
    this.productTelephoneCompany.product_types = "";
    if(this.productTelephoneCompany.mobiles === true){
      this.productTelephoneCompany.product_types += "1,";
    }
    if(this.productTelephoneCompany.consoles === true){
      this.productTelephoneCompany.product_types += "2,";
    }
    if(this.productTelephoneCompany.products === true){
      this.productTelephoneCompany.product_types += "3,";
    }
    if(this.productTelephoneCompany.laptops === true){
      this.productTelephoneCompany.product_types += "4,";
    }
    this.productTelephoneCompany.product_types = this.productTelephoneCompany.product_types.substring(0,this.productTelephoneCompany.product_types.length - 1);
  }

}





// WEBPACK FOOTER //
// ./src/app/configuration/components/product-telephone-companies/view-product-telephone-companies/view-product-telephone-companies.component.ts